import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";
//ckeditor

//utils
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";

//middleware
import moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";

registerLocale("es", es);

export const ManageIngestigadorInvitado = () => {
  let { isAdmin, userRoleId } = useSelector(({ user }) => user);

  const { INVESTIGADORES_INVITADOS } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();
  const [isCreate, setIsCreate] = useState(false);

  const [name, setName] = useState("");
  const [textEs, setTextEs] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textVa, setTextVa] = useState("");
  const [adjunto, setAdjunto] = useState();
  const [image, setImage] = useState();
  const [institucion, setInstitucion] = useState("");

  const [objetivoInstancia, setObjetivoInstacia] = useState("");
  const [categoriaInvestigadorInvitado, setCategoriaInvestigadorInvitado] =
    useState("");
  const [incoming, setIncoming] = useState("");
  const [periodos, setPeriodos] = useState([]);

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadEditData = async () => {
    try {
      let response = await getById(INVESTIGADORES_INVITADOS, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (p) => {
   setIncoming(p.incoming ? "1" : "0");

    setName(p.name);
    setTextEn(p.textEn);
    setTextEs(p.textEs);
    setTextVa(p.textVa);
    setInstitucion(p.institucion);
    setObjetivoInstacia(p.objetivoInstancia);
    
    setCategoriaInvestigadorInvitado(p.categoriaInvestigadorInvitado);
    setImage(p.image);
    setAdjunto(p.adjunto);
    setPeriodos(Array.isArray(p.periodos) ? p.periodos : []);
  };
  const handleAddPeriodo = () => {
    setPeriodos((prevPeriodos) => [
      ...(Array.isArray(prevPeriodos) ? prevPeriodos : []),
      { startDate: "", endDate: "" },
    ]);
  };    

  const handleRemovePeriodo = (index) => {
    setPeriodos(periodos.filter((_, i) => i !== index));
  };

  const handlePeriodoChange = (index, key, value) => {
    const updatedPeriodos = [...periodos];
    updatedPeriodos[index][key] = value;
    setPeriodos(updatedPeriodos);
  };

  const handleSubmit = () => {
    const investigadorInvitado = build();
    //     const notValid = validate(investigadorInvitado);
    //     if (notValid) {
    //       setMessage(notValid);
    //       setTimeout(() => setMessage(""), 4000);
    //       return;
    //     }
    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} investigador invitado?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(
      ({ isConfirmed }) =>
        isConfirmed && handleConfirmation(investigadorInvitado)
    );
  };

  const handleConfirmation = (investigadorInvitado) => {
    let createOrUpdate = isCreate
      ? create(INVESTIGADORES_INVITADOS, investigadorInvitado, source)
      : update(INVESTIGADORES_INVITADOS, id, investigadorInvitado, source);
    createOrUpdate
      .then(async ({ id: investigadorInvitadoId }) => {
        // const investigatorProjects = buildInvestigatorProject(
        //   chosenParticipants,
        //   chosenIps,
        //   projectId
        // );

        let createOrUpdateText = isCreate ? "creado" : "editado";

        Swal.fire({
          icon: "success",
          text: `Investigador externo ${createOrUpdateText} correctamente.`,
        });
        if (typeof image !== "string") {
          const formData = new FormData();
          formData.append("image", image);
          await saveFile(
            INVESTIGADORES_INVITADOS,
            investigadorInvitadoId,
            "image",
            formData,
            source
          );
        }
        if (typeof adjunto !== "string") {
          const formData = new FormData();
          formData.append("document", adjunto);
          await saveFile(
            INVESTIGADORES_INVITADOS,
            investigadorInvitadoId,
            "adjunto",
            formData,
            source
          );
        }
        history.push(
          `${ROUTES.InvestigadoresInvitados.all}/${investigadorInvitadoId}`
        );
        isMounted.current && setIsCreate(false);
        console.log(investigadorInvitado.periodos, "inv desde confirm");
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };

  const build = () => {
    const investigadorInvitado = {
      name,
      textEs,
      textEn,
      textVa,
      incoming: incoming === "1" ? 1 : 0,
      periodos,
      institucion,
      categoriaInvestigadorInvitado,
      objetivoInstancia,
 
    };
    console.log(investigadorInvitado.periodos, "desdebuild");

    return investigadorInvitado;
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Investigador externo
        </button>
      );
    }
    //if is update && logged user included as IP
    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Guardar cambios
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() =>
            deleteIt(
              INVESTIGADORES_INVITADOS,
              id,
              ROUTES.InvestigadoresInvitados.all,
              source
            )
          }
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };
  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Investigador externo </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setImage} image={image} />
            </div>
            <div className="col-6 d-flex justify-content-center">
              <ArchiveUploader handleFile={setAdjunto} archive={adjunto} />
            </div>
            <div className="col-6  d-flex flex-column  ">
              <small>Nombre y apellido</small>
              <input
                type="text"
                className="form-control"
                placeholder="*Nombre y apellido"
                value={name}
                onChange={({ target: { value } }) => setName(value)}
                // disabled={!allowedEdit}
              />
            </div>
          </div>
          <div className="form-row mt-2">
            <div className="col">
              <small>Biografía Español</small>
              <textarea
                className="form-control textarea"
                // placeholder="Resumen Español"
                rows={3}
                value={textEs ? textEs : ""}
                onChange={({ target: { value } }) => {
                  setTextEs(value);
                }}
              />
            </div>
            <div className="col">
              <small>Biografía Inglés</small>
              <textarea
                className="form-control textarea"
                // placeholder="Resumen Inglés"
                rows={3}
                value={textEn ? textEn : ""}
                onChange={({ target: { value } }) => {
                  setTextEn(value);
                }}
              />
            </div>
            <div className="col">
              <small>Biografía Valenciano</small>
              <textarea
                className="form-control textarea"
                // placeholder="Resumen Español"
                rows={3}
                value={textVa ? textVa : ""}
                onChange={({ target: { value } }) => {
                  setTextVa(value);
                }}
              />
            </div>
          </div>

          <div className="form-row mt-2">
            <div className="col">
              <span>Incoming</span>
              <select
                className="form-control input"
                value={incoming}
                onChange={({ target: { value } }) => {
                  setIncoming(value);
                }}
              >
                <option value="">Seleccione una opcion</option>
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Categoria </span>
              <select
                className="form-control input"
                value={categoriaInvestigadorInvitado}
                onChange={({ target: { value } }) => {
                  setCategoriaInvestigadorInvitado(value);
                }}
              >
                <option value="">Seleccione una opcion</option>
                <option value="Asociados">Asociados</option>
                <option value="Estancias">Estancias</option>
              </select>
            </div>

            <div className="col">
              <span>Objetivo instancia</span>
              <input
                type="text"
                className="form-control"
                placeholder="Objetivo instancia"
                value={objetivoInstancia}
                onChange={({ target: { value } }) => setObjetivoInstacia(value)}
                // disabled={!allowedEdit}
              />
            </div>

            <div className="col">
              <span>Institucion</span>
              <input
                type="text"
                className="form-control"
                placeholder="Institucion"
                value={institucion}
                onChange={({ target: { value } }) => setInstitucion(value)}
                //disabled={!allowedEdit}
              />
            </div>
          </div>
    
          <div className="mt-3">
            <label>Períodos</label>
            {periodos?.map((periodo, index) => (
              <div key={index} className="d-flex align-items-center mb-2">
                <DatePicker
                  selected={
                    periodo.startDate ? new Date(periodo.startDate) : null
                  }
                  onChange={(date) =>
                    handlePeriodoChange(index, "startDate", date)
                  }
                  className="form-control mr-2"
                  placeholderText="Fecha de inicio"
                  locale="es"
                  dateFormat="dd MMMM, yyyy "
                />
                <DatePicker
                  selected={periodo.endDate ? new Date(periodo.endDate) : null}
                  onChange={(date) =>
                    handlePeriodoChange(index, "endDate", date)
                  }
                  className="form-control mr-2 ml-2"
                  placeholderText="Fecha de fin"
                  locale="es"
                  dateFormat="dd MMMM, yyyy"
                />
                <button
                  className="btn btn-danger ml-2"
                  onClick={() => handleRemovePeriodo(index)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            ))}
            <button className="btn btn-primary mt-2" onClick={handleAddPeriodo}>
              Añadir período
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
